// Import constants
const ADDRESS_TYPES = require('./src/addressTypes');
const API = require('./src/api');
const CHANNEL_TYPES = require('./src/channelTypes');
const COLORS = require('./src/colors');
const CONTACT_POINT_SYSTEM = require('./src/contactPointSystem');
const CONTACT_POINT_USE = require('./src/contactPointUse');
const DAYS_OF_WEEK = require('./src/daysOfWeek');
const FILTER_OPS = require('./src/filterOps');
const FONTS = require('./src/fonts');
const FONT_SIZES = require('./src/fontSizes');
const GENDERS = require('./src/genders');
const JS_TYPES = require('./src/jsTypes');
const MESSAGE_TYPES = require('./src/messageTypes');
const NOTIFICATION_TYPES = require('./src/notificationTypes');
const NAME_USE = require('./src/nameUse');
const PLATFORM_TYPES = require('./src/platformTypes');
const PRIMARY_ROLES = require('./src/primaryRoles');
const QUALIFICATIONS = require('./src/qualifications');
const REASON_REFERENCES = require('./src/reasonReferences');
const REQUEST_TYPES = require('./src/requestTypes');
const SEXES = require('./src/sexes');
const STATES = require('./src/states');
const TAG_OWNER_TYPES = require('./src/tagOwnerTypes');
const TAG_TYPES = require('./src/tagTypes');
const TIME_UNITS = require('./src/timeUnits');
const UNITS = require('./src/units');
const USER_TYPES = require('./src/userTypes');
const WORKSPACE_TYPES = require('./src/workspaceTypes');
const LIBRARY_TYPES = require('./src/libraryTypes');
const PAGE_TYPES = require('./src/pageTypes');
const ORG_CONFIGS = require('./src/orgConfigs');
const CONFERENCE_ROOM_TYPES = require('./src/conferenceRoomTypes');
const CONFERENCE_ROOM_MESSAGE_TYPES = require('./src/conferenceRoomMessageTypes');
const CALENDAR_OBJECT_TYPES = require('./src/calendarObjectTypes');
const CALENDAR_OBJECT_OWNER_TYPES = require('./src/calendarObjectOwnerTypes');
const CALENDAR_OBJECT_RESPONSE_TYPES = require('./src/calendarObjectResponseTypes');
const AGE_CATEGORIES = require('./src/ageCategories');
const AUTH_SERVICES = require('./src/authServices');
const AUTH_USER_STATUSES = require('./src/authUserStatuses');
const DUPLEX_SERVICES = require('./src/duplexServices');
const NOTIFICATION_SERVICES = require('./src/notificationServices');
const QUERY_CONDITIONS = require('./src/query_conditions');

// Define General Constants
exports._0 = 0;
exports._1 = 1;

// Define error code
exports.ErrorCode = class ErrorCode extends Error {
  constructor(httpStatusCode, message, log = null) {
    super(message);
    this.httpStatusCode = httpStatusCode;
    if(log) {
      console.log(log);
    }
  }
};

// Collect UI components
const UI = {
  ADDRESS_TYPES,
  API_METHODS: API.METHODS,
  API_AUTH_TYPES: API.AUTH_TYPES,
  API_GATEWAY_TYPES: API.GATEWAY_TYPES,
  API_HEADER_CONTENT_TYPES: API.HEADER_CONTENT_TYPES,
  CHANNEL_TYPES,
  CONTACT_POINT_SYSTEM,
  CONTACT_POINT_USE,
  DAYS_OF_WEEK,
  GENDERS,
  JS_TYPES,
  MESSAGE_TYPES,
  NOTIFICATION_TYPES,
  NAME_USE,
  PLATFORM_TYPES,
  PRIMARY_ROLES,
  QUALIFICATIONS,
  REASON_REFERENCES,
  REQUEST_TYPES,
  SEXES,
  STATES,
  TAG_OWNER_TYPES,
  TAG_TYPES,
  TIME_UNITS,
  UNITS,
  USER_TYPES,
  WORKSPACE_TYPES,
  LIBRARY_TYPES,
  PAGE_TYPES,
  ORG_CONFIGS,
  CONFERENCE_ROOM_TYPES,
  CONFERENCE_ROOM_MESSAGE_TYPES,
  CALENDAR_OBJECT_TYPES,
  CALENDAR_OBJECT_OWNER_TYPES,
  CALENDAR_OBJECT_RESPONSE_TYPES,
  AGE_CATEGORIES,
  AUTH_SERVICES,
  AUTH_USER_STATUSES,
  DUPLEX_SERVICES,
  NOTIFICATION_SERVICES,
  QUERY_CONDITIONS
};
exports.UI = UI;

// Export JS keys
const UIElementKeyExtractor = (obj) => {
  let res = {};
  Object.keys(obj).forEach(o => res[o] = o);
  return res;
};

exports.ADDRESS_TYPES = UIElementKeyExtractor(UI.ADDRESS_TYPES);
exports.API_AUTH_TYPES = UIElementKeyExtractor(UI.API_AUTH_TYPES);
exports.API_METHODS = UIElementKeyExtractor(UI.API_METHODS);
exports.API_GATEWAY_TYPES = UIElementKeyExtractor(UI.API_GATEWAY_TYPES);
exports.API_HEADER_CONTENT_TYPES = UIElementKeyExtractor(UI.API_HEADER_CONTENT_TYPES);
exports.CHANNEL_TYPES = UIElementKeyExtractor(UI.CHANNEL_TYPES);
exports.COLORS = COLORS;
exports.CONTACT_POINT_SYSTEM = UIElementKeyExtractor(UI.CONTACT_POINT_SYSTEM);
exports.CONTACT_POINT_USE = UIElementKeyExtractor(UI.CONTACT_POINT_USE);
exports.DAYS_OF_WEEK = UIElementKeyExtractor(UI.DAYS_OF_WEEK);
exports.FONTS = FONTS;
exports.FONT_SIZES = FONT_SIZES;
exports.GENDERS = UIElementKeyExtractor(UI.GENDERS);
exports.JS_TYPES = UIElementKeyExtractor(UI.JS_TYPES);
exports.MESSAGE_TYPES = UIElementKeyExtractor(UI.MESSAGE_TYPES);
exports.NOTIFICATION_TYPES = UIElementKeyExtractor(UI.NOTIFICATION_TYPES);
exports.NAME_USE = UIElementKeyExtractor(UI.NAME_USE);
exports.PRIMARY_ROLES = UIElementKeyExtractor(UI.PRIMARY_ROLES);
exports.QUALIFICATIONS = UIElementKeyExtractor(UI.QUALIFICATIONS);
exports.REASON_REFERENCES = UIElementKeyExtractor(UI.REASON_REFERENCES);
exports.REQUEST_TYPES = UIElementKeyExtractor(UI.REQUEST_TYPES);
exports.SEXES = UIElementKeyExtractor(UI.SEXES);
exports.STATES = UIElementKeyExtractor(UI.STATES);
exports.TAG_OWNER_TYPES = UIElementKeyExtractor(UI.TAG_OWNER_TYPES);
exports.TAG_TYPES = UIElementKeyExtractor(UI.TAG_TYPES);
exports.TIME_UNITS = UIElementKeyExtractor(UI.TIME_UNITS);
exports.USER_TYPES = UIElementKeyExtractor(UI.USER_TYPES);
exports.WORKSPACE_TYPES = UIElementKeyExtractor(UI.WORKSPACE_TYPES);
exports.LIBRARY_TYPES = UIElementKeyExtractor(UI.LIBRARY_TYPES);
exports.PAGE_TYPES = UIElementKeyExtractor(UI.PAGE_TYPES);
exports.ORG_CONFIGS = UIElementKeyExtractor(UI.ORG_CONFIGS);
exports.CONFERENCE_ROOM_TYPES = UIElementKeyExtractor(UI.CONFERENCE_ROOM_TYPES);
exports.CONFERENCE_ROOM_MESSAGE_TYPES = UIElementKeyExtractor(UI.CONFERENCE_ROOM_MESSAGE_TYPES);
exports.CALENDAR_OBJECT_TYPES = UIElementKeyExtractor(UI.CALENDAR_OBJECT_TYPES);
exports.CALENDAR_OBJECT_OWNER_TYPES = UIElementKeyExtractor(UI.CALENDAR_OBJECT_OWNER_TYPES);
exports.CALENDAR_OBJECT_RESPONSE_TYPES = UIElementKeyExtractor(UI.CALENDAR_OBJECT_RESPONSE_TYPES);
exports.AGE_CATEGORIES = UIElementKeyExtractor(UI.AGE_CATEGORIES);
exports.AUTH_SERVICES = UIElementKeyExtractor(UI.AUTH_SERVICES);
exports.AUTH_USER_STATUSES = UIElementKeyExtractor(UI.AUTH_USER_STATUSES);
exports.DUPLEX_SERVICES = UIElementKeyExtractor(UI.DUPLEX_SERVICES);
exports.NOTIFICATION_SERVICES = UIElementKeyExtractor(UI.NOTIFICATION_SERVICES);
exports.QUERY_CONDITIONS = UIElementKeyExtractor(UI.QUERY_CONDITIONS);

exports.PAGING = {
  START: 1,
  END: 'all',
  WRITE_SIZE: 25,
  READ_SIZE: 50,
};

exports.COMMAND_TYPES = {
  PutItemCommand: 'PutItemCommand',
  GetItemCommand: 'GetItemCommand',
  UpdateItemCommand: 'UpdateItemCommand',
  DeleteItemCommand: 'DeleteItemCommand',
  BatchWriteItemCommand: 'BatchWriteItemCommand',
  BatchGetItemCommand: 'BatchGetItemCommand',
  BatchDeleteItemCommand: 'BatchDeleteItemCommand',
  TransactWriteItemsCommand: 'TransactWriteItemsCommand',
  QueryCommand: 'QueryCommand'
};

exports.TERMINATE = '#TERMINATE#';

exports.WEBSOCKET_CALL_TYPES = {
  CONNECT: 'CONNECT',
  DISCONNECT: 'DISCONNECT',
  MESSAGE: 'MESSAGE',
};

exports.TABLE_SUFFIX = {
  data: 'data',
  map: 'map',
  message: 'message',
  websocket: 'websocket',
  webrtc: 'webrtc',
  conferenceRoom: 'conferenceRoom',
  tag: 'tag',
  notification: 'notification',
  authUser: 'authUser',
  authUserToken: 'authUserToken',
};

exports.BCM_KEYS = {
  pk: 'pk',
  sk: 'sk',
  gsipk: 'gsipk',
  gsisk: 'gsisk'
};

exports.SCHEMA_KEY_SPLIT_CHAR = '#';
exports.SCHEMA_KEY_INPUT_START_CHAR = '{';
exports.SCHEMA_KEY_INPUT_END_CHAR = '}';

exports.FILTER_OPS = FILTER_OPS;